import ProductController from "../../controller/ProductController";
import {useParams} from "react-router-dom";
import {useContext, useEffect} from "react";
import {MarketContext} from "../../../Main/context/MarketContext";
import {useTranslation} from "react-i18next";

export default function ProductError({message, productController}: {
    message: string,
    productController: ProductController | null
}) {
    const {t} = useTranslation();
    const context = useContext(MarketContext);
    const categoryId = context.state.categoryActive === 'all' ? "" : context.state.categoryActive
    const {shopId} = useParams();

    useEffect(() => {
        window.scrollTo({top: document.body.scrollHeight, behavior: 'smooth'});
    });

    return (
        <div className={'error-product-list'}>
            <p>{message}</p>
            <button onClick={e => productController?.initProduct(categoryId, shopId)}>{t("tryAgain")}</button>
        </div>
    )
}